import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    question: '¿Es material digital?',
    answer: 'Sí. Acceso y descarga inmediata.'
  }, {
    question: '¿Sirve para clases presenciales y virtuales?',
    answer: 'Sí, es adaptable a ambos formatos.'
  }, {
    question: '¿Está alineado a primaria?',
    answer: 'Sí. Diseñado específicamente para nivel primario.'
  }, {
    question: '¿Necesito experiencia previa?',
    answer: 'No. Todo está estructurado paso a paso.'
  }];
  return <section className="bg-white py-10 px-4" data-id="element-40">
      <div className="max-w-3xl mx-auto" data-id="element-41">
        <h2 className="text-2xl md:text-3xl font-black text-center text-gray-900 mb-6 font-['Oswald'] uppercase" data-id="element-42">
          Preguntas frecuentes
        </h2>

        <div className="space-y-3" data-id="element-43">
          {faqs.map((faq, idx) => <FAQItem key={idx} question={faq.question} answer={faq.answer} data-id="element-44" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-45">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-4 bg-gray-50 hover:bg-gray-100 transition-colors text-left" data-id="element-46">
        <span className="font-bold text-base text-gray-900" data-id="element-47">{question}</span>
        {isOpen ? <ChevronUp className="w-4 h-4 text-gray-500" data-id="element-48" /> : <ChevronDown className="w-4 h-4 text-gray-500" data-id="element-49" />}
      </button>
      {isOpen && <div className="p-4 bg-white border-t border-gray-200 text-gray-700 text-sm" data-id="element-50">
          {answer}
        </div>}
    </div>;
}